import { ITableRowData } from "../../../shared/components/normal-table/normal-table";

interface IBackendTemplateRow {
  name: string;
  tenant_assigned: boolean;
  id: string;
  is_global: boolean;
  sygno_default: boolean;
  is_installation: boolean;
  tenant_default: boolean;
}

interface IBackendTemplateLayout {
  data: IBackendTemplateRow[];
}

interface FrontendTemplateLayout {
  rowData: ITableRowData[];
}

export function transformToBackendTemplateLayout(data: FrontendTemplateLayout): IBackendTemplateLayout {
  return {
    data: data.rowData.map((row) => ({
      name: row.name,
      tenant_assigned: row.tenant_assigned,
      id: row.id,
      is_global: row.is_global,
      sygno_default: row.sygno_default,
      is_installation: row.is_installation,
      tenant_default: row.tenant_default,
    })),
  };
}

export function transformFromBackendTemplateLayout(backendData: IBackendTemplateLayout): FrontendTemplateLayout {
  return {
    rowData: backendData.data.map((row) => ({
      name: row.name,
      tenant_assigned: row.tenant_assigned,
      id: row.id,
      is_global: row.is_global,
      sygno_default: row.sygno_default,
      is_installation: row.is_installation,
      tenant_default: row.tenant_default,
    })),
  };
}
